export default "__VITE_ASSET__bf1bec0e__"